import { render, staticRenderFns } from "./BooksManage.vue?vue&type=template&id=0cdb5be8&"
import script from "./BooksManage.vue?vue&type=script&lang=js&"
export * from "./BooksManage.vue?vue&type=script&lang=js&"
import style0 from "./BooksManage.vue?vue&type=style&index=0&id=0cdb5be8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports